module.exports = __webpack_public_path__ + "img/烧烤箱.edc50c0c.png";